export class StatusDate {
    createdDate: Date;
    poRaisedDate: Date;
    readyToShipDate: Date;
    pickupScheduledDate: Date;
    pickupCancelDate: Date;
    shippedDate: Date;
    deliveredDate: Date;
}